import instance from "./baseRequest";

export const aboutStatsSectionApi = {
  getAboutStatsSection: async () =>
    await instance.get("/admin/about-stats-section"),
  updateAboutStatsSection: async (data) => {
    return await instance.put("/admin/about-stats-section", data);
  },
};
